import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sc-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: [
    './pagination.component.css'
  ]
})

export class PaginationComponent implements OnInit {

  @Input('theme') public theme: string;
  @Input() public pageSizes: number[];
  @Input() public totalNumberOfPages;

  @Output('nextPageEvent') public nextPageEventEmitter = new EventEmitter();
  @Output('prevPageEvent') public prevPageEventEmitter = new EventEmitter();
  @Output('onChangePageSizeEvent') public onChangePageSizeEventEmitter = new EventEmitter();

  public currentPageNumber: number = 0;
  public pageSize: number = 0;

  constructor() {}

  public ngOnInit(): void {
    if (this.pageSizes.length > 0) {
      this.pageSize = this.pageSizes[0];
    }
  }

  public nextPage() {
    if ((this.currentPageNumber + 1) < this.totalNumberOfPages) {
      this.currentPageNumber++;
      this.nextPageEventEmitter.emit(this.currentPageNumber);
    }
  }

  public previousPage() {
    if (this.currentPageNumber > 0) {
      this.currentPageNumber--;
      this.prevPageEventEmitter.emit(this.currentPageNumber);
    }
  }

  public onChangePageSize(event) {
    this.currentPageNumber = 0;
    this.onChangePageSizeEventEmitter.emit(event);
  }
}
